'use client';

import { useState, useEffect, useCallback } from 'react';
import { getGeneralSettings } from '../api';
import type { GeneralSettings } from '../types';

export function useGeneralSettings(tenantSlug?: string) {
  const [data, setData] = useState<GeneralSettings | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchSettings = useCallback(async (forceRefetch = false) => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await getGeneralSettings(tenantSlug, forceRefetch);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch general settings'));
    } finally {
      setIsLoading(false);
    }
  }, [tenantSlug]);

  useEffect(() => {
    fetchSettings(false);
  }, [fetchSettings]);

  return {
    generalSettings: data,
    isLoading,
    error,
    refetch: () => fetchSettings(true),
  };
}
